// Styles entry
import './main.scss'

//Icons
import 'virtual:svg-icons-register'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ErrorMessage from './components/organisms/ErrorMessage/ErrorMessage.vue'
import App from './App.vue'
import router, { dynamicRoutes } from './router'
import i18n from '@/locales/dictionary'
import mitt from 'mitt';
import { useAppConfigurationStore } from '@/stores/useAppConfigurationStore'
import { json } from 'stream/consumers'
import { useHostNameStore } from './stores/useHostNameStore'
import { createGtm } from '@gtm-support/vue-gtm';
import * as Sentry from "@sentry/vue";
import Popper from "vue3-popper";
import "./popper-theme.css"; //

window.onerror = function(message, source, lineno, colno, error) {
  if (typeof clarity === "function") {
      clarity("set", "error", {
          message: message,
          source: source,
          lineno: lineno,
          colno: colno,
          stack: error?.stack || "No stack trace",
      });
  } else {
      console.warn("Clarity is not installed. Error details:", {
          message: message,
          source: source,
          lineno: lineno,
          colno: colno,
          stack: error?.stack || "No stack trace",
      });
  }
};


const isProduction = import.meta.env.VITE_NODE_ENV === 'production';

const eventBus = mitt();
const app = createApp(App)

app.config.errorHandler = (err, instance, info) => {
  const error = err as Error;
  if (typeof clarity === "function") {
      clarity("set", "error", {
          message: error.message,
          stack: error.stack,
          info,
      });
  } else {
      console.error("Vue Error:", {
          message: error.message,
          stack: error.stack,
          info,
      });
  }
};

app.component("Popper", Popper)

app.provide('eventBus', eventBus);

if (isProduction) {
  Sentry.init({
    app,
    dsn: "https://271dc905ddf1ca59ea730c05a6452a27@o4508691902169088.ingest.de.sentry.io/4508691956039760",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", "events.dn.dk", "events.affaldsindsamlingen.dk","events.naturensuge.dk", "lokaleevents.dn.dk","mineture.tidtiltur.dk"],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

app.use(createPinia())

app.use(i18n)

const hostNameStore = useHostNameStore()
const appConfigurationStore = useAppConfigurationStore()
console.log('hostname: ' + hostNameStore.hostname)

dynamicRoutes(router)
app.use(router)
//replaceRoute(router)
//console.log('routes' + JSON.stringify(router.getRoutes()))

app.use(
  createGtm({
    id: "GTM-5B2CH2JR",
    vueRouter: router
  })
)

app.component('ErrorMessage', ErrorMessage)
app.mount('#app')

router.isReady().then(() => {
  //  app.mount('#app')
});


//app.config.globalProperties.eventBus = eventBus